// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"_21e4d189","header":"da05143c","subtitle":"e3e499c0","content":"_713d8810"};


//////////////////
// WEBPACK FOOTER
// ./src/components/common/Charts/InfoWrapper/styles.styl
// module id = 5190
// module chunks = 39